import React from 'react';
import { Accordion, OptForm } from '../components';
import faqsData from '../fixtures/faqs';

export function FaqsContainer() {
  return (
    <Accordion>
      <Accordion.Title>Frequently Asked Questions</Accordion.Title>
      <Accordion.Frame>
        {faqsData.map((item) => (
          <Accordion.Item key={item.id}>
            <Accordion.Header>{item.header}</Accordion.Header>
            <Accordion.Body>{item.body}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion.Frame>

      <OptForm>
        <OptForm.Input readonly placeholder="Mansour.mahamat.salle@gmail.com" />

        <OptForm.Button href="mailto:Mansour.mahamat.salle@gmail.com">
          Contact me
        </OptForm.Button>
        <OptForm.Break />
        <OptForm.Text>
          Ready to talk with me ? Click the red button and send me an email.
        </OptForm.Text>
      </OptForm>
    </Accordion>
  );
}
